<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="container">
      <popup-banner-editor v-model="form"></popup-banner-editor>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import PopupBannerEditor from "../components/PopupBannerEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadImage, getPublicImageUrl } from "@/god";
import { isNil, isEmpty } from "ramda";

export default {
  components: {
    PageWrapper,
    ScButton,
    PopupBannerEditor
  },
  data() {
    const title = "เพิ่ม Popup Banner";

    return {
      title,
      form: {
        imageFile: null,
        title: "",
        publishDate: [],
        webUrl: null
      }
    };
  },

  methods: {
    async handleClickSave() {
      try {
        await this.createPopupBanner();
        this.$router.push({ name: "PopupBannerListPage" });
      } catch (err) {
        console.error(err);
        alert("ไม่สามารถสร้าง Popup Banner ได้");
      }
    },
    async createPopupBanner() {
      const {
        title,
        imageFile,
        publishDate: publishDateForm,
        webUrl
      } = this.form;

      const imageUrl = await this.uploadPublicImage(imageFile);

      const [start, end] = publishDateForm;
      const publishDate = {
        start: start.toISO(),
        end: end.toISO()
      };
      const params = {
        title,
        imageUrl,
        publishDate,
        webUrl: !isNil(webUrl) && !isEmpty(webUrl) ? webUrl.trim() : null
      };

      await baanRueJaiClient.admin.communications.popupBanners.post(params);
    },
    async uploadPublicImage(file) {
      const image = await uploadImage(file, file.name, "article");
      const { url } = await getPublicImageUrl(image);

      return url;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/popupBanner/pages/PopupBannerCreatePage.vue